// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"1c6394b5","888":"102bf720"}[chunkId] + ".chunk.css";
};